import React, { createContext, useContext, useEffect, useState } from "react";
import { db } from "./Firebase";
import { collection, onSnapshot } from "firebase/firestore";

// contexto para los datos
const DataContext = createContext();

// Proveedor de datos para administrar los datos en la aplicación
export const DataProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [sueldoData, setSueldoData] = useState([]);
  const [fechaData, setFechaData] = useState([]);
  const [baseData, setBaseData] = useState([]);
  const [viaticoData, setViaticoData] = useState([]);
  const [viaticosInternacionalesData, setViaticosInternacionalesData] = useState([]);
  const [viaticosNacionalesData, setViaticosNacionalesData] = useState([]);
  const [tasaData, setTasaData] = useState([]);
  const [peajeData, setPeajeData] = useState([]);
  const [costoUnidadesData, setCostoUnidadesData] = useState([]);

  // Función para cargar los datos desde Firebase
  useEffect(() => {
    const unsubscribeFecha = onSnapshot(collection(db, "fechaActualizacionCostos"), (snapshot) => {
      setFechaData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribeTasa = onSnapshot(collection(db, "TasaEmbarque"), (snapshot) => {
      setTasaData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribePeaje = onSnapshot(collection(db, "peajes"), (snapshot) => {
      setPeajeData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribeSueldo = onSnapshot(collection(db, "sueldoChofer"), (snapshot) => {
      setSueldoData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribeBase = onSnapshot(collection(db, "btm"), (snapshot) => {
      setBaseData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribeViatico = onSnapshot(collection(db, "viaticoProvincial"), (snapshot) => {
      setViaticoData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribeViaticosInternacionales = onSnapshot(collection(db, "viaticosInternacionales"), (snapshot) => {
      setViaticosInternacionalesData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribeViaticosNacionales = onSnapshot(collection(db, "viaticosNacionales"), (snapshot) => {
      setViaticosNacionalesData(snapshot.docs.map((doc) => doc.data()));
    });
  
    const unsubscribeCostoUnidades = onSnapshot(collection(db, "costoUnidades"), (snapshot) => {
      setCostoUnidadesData(snapshot.docs.map((doc) => doc.data()));
    });
  
    setLoading(false);
  
    // Cleanup: Cancelar suscripciones cuando el componente se desmonte
    return () => {
      unsubscribeFecha();
      unsubscribeTasa();
      unsubscribePeaje();
      unsubscribeSueldo();
      unsubscribeBase();
      unsubscribeViatico();
      unsubscribeViaticosInternacionales();
      unsubscribeViaticosNacionales();
      unsubscribeCostoUnidades();
    };
  }, []);

  return (
    <DataContext.Provider
      value={{
        loading,
        fechaData,
        tasaData,
        peajeData,
        sueldoData,
        baseData,
        viaticoData,
        viaticosInternacionalesData,
        viaticosNacionalesData,
        costoUnidadesData,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

// Hook personalizado para acceder a los datos desde otros componentes
export const useData = () => {
  return useContext(DataContext);
};